import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../theme';

const useCommonStyles = makeStyles((theme: Theme) => {
  return createStyles({
    modalWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
    },
    modalContainer: {
      background: theme.palette.secondary.main,
      borderRadius: 5,
      maxWidth: 600,
      padding: `${MIDDLE_MARGIN}px ${SMALL_MARGIN}px`,
      position: 'relative',
      margin: `0 ${SMALL_MARGIN}px`,
      [theme.breakpoints.up('md')]: {
        padding: LARGE_MARGIN,
      },
    },
    modalCloseBtn: {
      position: 'absolute',
      display: 'block',
      cursor: 'pointer',
      height: 14,
      width: 14,
      top: 16,
      right: 29,
      [theme.breakpoints.up('md')]: {
        top: 29,
      },
    },
    reachText: {
      color: colorsPalette.gray,
      '& h1,& h2,& h3,& h4,& h5,& h6,& p,& ul,& ol': {
        marginBottom: SMALL_MARGIN,
        marginTop: 0,
      },
      '& h1,& h2,& h3,& h4,& h5,& h6': {
        color: colorsPalette.white,
        lineHeight: 1.2,
      },
      '& ul, & ol': {
        paddingLeft: 20,
        '& li': {
          '&::marker': {
            color: colorsPalette.turquoiseLight,
          },
        },
      },
      '& a, & a>span': {
        // no way to avoid !important, editor add inline style with color to span
        color: `${colorsPalette.white} !important`,
      },
    },
  });
});

export default useCommonStyles;
